// Every UI catalog by language code. The language menu lists them in this order (the boards show Hebrew first);
// a new language is a new catalog here.
import en from './en';
import he from './he';

const catalogs = { he, en };

export default catalogs;
